import { NODE_TYPES, NODE_TYPE_PERSON } from "../components/Node/config";

/**
 * @name createDefaultNode
 * @function
 * @description Creates a new default node
 * @returns {object}
 */
export const createDefaultNode = () => ({ 
    evidence: [],
    details: {},
    connections: [] 
});

/**
 * @name createWalkthroughNode
 * @function
 * @description Creates a new random node for the walkthrough
 * @returns {object} A node
 */
export const createWalkthroughNode = () => {

    const names = [ 
        'Alex Jones',
        'Seth Rich',
        'Bill Gates',
        'Ghislaine Maxwell',
        'Jeffery Epstein', 
        'Hillary Clinton', 
        'Klaus Schwab', 
        'George Soros' 
    ],
    randomNumber = Math.floor( Math.random() * ( names.length - 1 ) );
    
    return { 
        ...createDefaultNode(),
        type: NODE_TYPE_PERSON,
        name: names[ randomNumber ],
        walkthrough: true
    };

}

/**
 * @name isValid
 * @function
 * @description Determines if a board is renderable... more or less
 * @param {object} board board being validated
 */
export const isValid = board => {

    // high level check
    const basic =  (
        ( board.hasOwnProperty( 'nodes' ) && typeof board.nodes === 'object' ) &&
        ( board.hasOwnProperty( 'connections' ) && typeof board.connections === 'object' ) &&
        ( board.hasOwnProperty( 'zoom' ) && typeof board.zoom === 'number' )
    );

    if( !basic ) return false;

    // check node validity
    for( let key in board.boards ){
        const node = board.nodes[ key ];
        if( !validId( key ) ) return false;

        if( typeof node.name !== 'string' ) return false;
        if( typeof node.type !== 'string' || !NODE_TYPES.includes( node.type ) ) return false;
        if( typeof node.connections !== 'object' || !Array.isArray( node.connections ) ) return false;
        if( typeof node.details !== 'object' ) return false;

        // validate connections
        for( let x = 0; x < node.connections.length; ++x ){
            if( !validId( node.connections[ x ] ) ) return false;
        }
    }

    // check connection validity
    for( let key in board.connections ){
        const connection = board.connections[ key ];
        if( !validId( key ) ) return false;

        if( typeof connection !== 'object' || !Array.isArray( connection ) ) return false;

        // validate connections
        for( let x = 0; x < connection.length; ++x ){
            if( !validId( connection[ x ] ) ) return false;
        }
    }

    return true;
}

/**
 * @name validId
 * @function
 * @description Determines if a provided string is a valid UUID
 * @param {string} id 
 * @returns {boolean}
 */
const validId = id => {
    return ( id.length === 36 );
}